// Audio files for webchat sound effects
export const SOUND_EFFECTS = {
  // Optimized OGG file (4.4KB instead of 124KB WAV)
  chatMessageNotification: new URL('./chatMessageNotification.ogg', import.meta.url).href,
} as const
